/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationV2GoalkeeperState } from './MatchOperationV2GoalkeeperState';
import {
    MatchOperationV2GoalkeeperStateFromJSON,
    MatchOperationV2GoalkeeperStateFromJSONTyped,
    MatchOperationV2GoalkeeperStateToJSON,
    MatchOperationV2GoalkeeperStateToJSONTyped,
} from './MatchOperationV2GoalkeeperState';
import type { MatchOperationV2TeamStatistics } from './MatchOperationV2TeamStatistics';
import {
    MatchOperationV2TeamStatisticsFromJSON,
    MatchOperationV2TeamStatisticsFromJSONTyped,
    MatchOperationV2TeamStatisticsToJSON,
    MatchOperationV2TeamStatisticsToJSONTyped,
} from './MatchOperationV2TeamStatistics';
import type { MatchOperationV2ParticipantStatistics } from './MatchOperationV2ParticipantStatistics';
import {
    MatchOperationV2ParticipantStatisticsFromJSON,
    MatchOperationV2ParticipantStatisticsFromJSONTyped,
    MatchOperationV2ParticipantStatisticsToJSON,
    MatchOperationV2ParticipantStatisticsToJSONTyped,
} from './MatchOperationV2ParticipantStatistics';

/**
 * 
 * @export
 * @interface MatchOperationV2State
 */
export interface MatchOperationV2State {
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2State
     */
    revision: number;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2State
     */
    status: MatchOperationV2StateStatus;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2State
     */
    currentPeriod: number;
    /**
     * 
     * @type {boolean}
     * @memberof MatchOperationV2State
     */
    clockRunning: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2State
     */
    periodElapsedAnchorMs: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2State
     */
    effectiveElapsedAnchorMs: number;
    /**
     * 
     * @type {Date}
     * @memberof MatchOperationV2State
     */
    clockAnchorAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MatchOperationV2State
     */
    periodDeadlineAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2State
     */
    scoreTeamA: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2State
     */
    scoreTeamB: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2State
     */
    teamATimeoutsUsed: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2State
     */
    teamBTimeoutsUsed: number;
    /**
     * 
     * @type {MatchOperationV2GoalkeeperState}
     * @memberof MatchOperationV2State
     */
    goalkeepers: MatchOperationV2GoalkeeperState;
    /**
     * 
     * @type {Array<MatchOperationV2ParticipantStatistics>}
     * @memberof MatchOperationV2State
     */
    participantStatistics: Array<MatchOperationV2ParticipantStatistics>;
    /**
     * 
     * @type {MatchOperationV2TeamStatistics}
     * @memberof MatchOperationV2State
     */
    teamStatistics: MatchOperationV2TeamStatistics;
    /**
     * Display TEAM_B on the left and TEAM_A on the right without changing team identities or statistics.
     * @type {boolean}
     * @memberof MatchOperationV2State
     */
    sidesSwapped: boolean;
}

/**
* @export
* @enum {string}
*/
export enum MatchOperationV2StateStatus {
    NotStarted = 'NOT_STARTED',
    Running = 'RUNNING',
    Paused = 'PAUSED',
    PeriodComplete = 'PERIOD_COMPLETE',
    Finished = 'FINISHED'
}


/**
 * Check if a given object implements the MatchOperationV2State interface.
 */
export function instanceOfMatchOperationV2State(value: object): value is MatchOperationV2State {
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('currentPeriod' in value) || value['currentPeriod'] === undefined) return false;
    if (!('clockRunning' in value) || value['clockRunning'] === undefined) return false;
    if (!('periodElapsedAnchorMs' in value) || value['periodElapsedAnchorMs'] === undefined) return false;
    if (!('effectiveElapsedAnchorMs' in value) || value['effectiveElapsedAnchorMs'] === undefined) return false;
    if (!('scoreTeamA' in value) || value['scoreTeamA'] === undefined) return false;
    if (!('scoreTeamB' in value) || value['scoreTeamB'] === undefined) return false;
    if (!('teamATimeoutsUsed' in value) || value['teamATimeoutsUsed'] === undefined) return false;
    if (!('teamBTimeoutsUsed' in value) || value['teamBTimeoutsUsed'] === undefined) return false;
    if (!('goalkeepers' in value) || value['goalkeepers'] === undefined) return false;
    if (!('participantStatistics' in value) || value['participantStatistics'] === undefined) return false;
    if (!('teamStatistics' in value) || value['teamStatistics'] === undefined) return false;
    if (!('sidesSwapped' in value) || value['sidesSwapped'] === undefined) return false;
    return true;
}

export function MatchOperationV2StateFromJSON(json: any): MatchOperationV2State {
    return MatchOperationV2StateFromJSONTyped(json, false);
}

export function MatchOperationV2StateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2State {
    if (json == null) {
        return json;
    }
    return {
        
        'revision': json['revision'],
        'status': json['status'],
        'currentPeriod': json['currentPeriod'],
        'clockRunning': json['clockRunning'],
        'periodElapsedAnchorMs': json['periodElapsedAnchorMs'],
        'effectiveElapsedAnchorMs': json['effectiveElapsedAnchorMs'],
        'clockAnchorAt': json['clockAnchorAt'] == null ? undefined : (new Date(json['clockAnchorAt'])),
        'periodDeadlineAt': json['periodDeadlineAt'] == null ? undefined : (new Date(json['periodDeadlineAt'])),
        'scoreTeamA': json['scoreTeamA'],
        'scoreTeamB': json['scoreTeamB'],
        'teamATimeoutsUsed': json['teamATimeoutsUsed'],
        'teamBTimeoutsUsed': json['teamBTimeoutsUsed'],
        'goalkeepers': MatchOperationV2GoalkeeperStateFromJSON(json['goalkeepers']),
        'participantStatistics': ((json['participantStatistics'] as Array<any>).map(MatchOperationV2ParticipantStatisticsFromJSON)),
        'teamStatistics': MatchOperationV2TeamStatisticsFromJSON(json['teamStatistics']),
        'sidesSwapped': json['sidesSwapped'],
    };
}

export function MatchOperationV2StateToJSON(json: any): MatchOperationV2State {
    return MatchOperationV2StateToJSONTyped(json, false);
}

export function MatchOperationV2StateToJSONTyped(value?: MatchOperationV2State | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'revision': value['revision'],
        'status': value['status'],
        'currentPeriod': value['currentPeriod'],
        'clockRunning': value['clockRunning'],
        'periodElapsedAnchorMs': value['periodElapsedAnchorMs'],
        'effectiveElapsedAnchorMs': value['effectiveElapsedAnchorMs'],
        'clockAnchorAt': value['clockAnchorAt'] == null ? value['clockAnchorAt'] : value['clockAnchorAt'].toISOString(),
        'periodDeadlineAt': value['periodDeadlineAt'] == null ? value['periodDeadlineAt'] : value['periodDeadlineAt'].toISOString(),
        'scoreTeamA': value['scoreTeamA'],
        'scoreTeamB': value['scoreTeamB'],
        'teamATimeoutsUsed': value['teamATimeoutsUsed'],
        'teamBTimeoutsUsed': value['teamBTimeoutsUsed'],
        'goalkeepers': MatchOperationV2GoalkeeperStateToJSON(value['goalkeepers']),
        'participantStatistics': ((value['participantStatistics'] as Array<any>).map(MatchOperationV2ParticipantStatisticsToJSON)),
        'teamStatistics': MatchOperationV2TeamStatisticsToJSON(value['teamStatistics']),
        'sidesSwapped': value['sidesSwapped'],
    };
}

